const zaokruhliNa2 = (cislo) => Math.round((Number(cislo) || 0) * 100) / 100;

export function vypocitajVysledokInvestovania({
  invOpen,
  invJednoraz,
  invMesacne,
  invZhodnotenie,
  invHorizont,
  roky,
  zostatky,
}) {
  if (!invOpen) return null;

  const jednorazovyVklad = Math.max(0, Number(invJednoraz) || 0);
  const mesacnyVklad = Math.max(0, Number(invMesacne) || 0);
  const maVklady = jednorazovyVklad > 0 || mesacnyVklad > 0;

  if (!maVklady) return null;

  const rocneZhodnotenie = Math.max(0, Number(invZhodnotenie) || 0) / 100;
  const mesacneZhodnotenie = Math.pow(1 + rocneZhodnotenie, 1 / 12) - 1;

  const horizontRoky = Math.min(99, Math.max(0, Number(invHorizont) || 0));
  const horizontMesiace = horizontRoky * 12;

  const dlzkaHypoMesiace = Math.max(1, (Number(roky) || 0) * 12);
  const dlzkaGrafu = Math.max(dlzkaHypoMesiace, horizontMesiace);

  let stavInvesticie = jednorazovyVklad;
  const priebehKrivky = new Array(dlzkaGrafu).fill(0);

  for (let m = 1; m <= dlzkaGrafu; m++) {
    if (m <= horizontMesiace) {
      stavInvesticie += mesacnyVklad; // optimistický model = vklad na začiatku mesiaca
    }

    stavInvesticie *= (1 + mesacneZhodnotenie);

    // BEZ zaokrúhľovania počas výpočtu
    priebehKrivky[m - 1] = stavInvesticie;
  }

  const indexKoncaHorizontu = Math.min(horizontMesiace, dlzkaGrafu) - 1;

  const konecnyStavBezPS = horizontMesiace > 0 && indexKoncaHorizontu >= 0
    ? priebehKrivky[indexKoncaHorizontu]
    : jednorazovyVklad;

  const celkoveVklady = jednorazovyVklad + (mesacnyVklad * horizontMesiace);
  const celkovyVynos = Math.max(0, konecnyStavBezPS - celkoveVklady);

  let mesiacSplatenia = null;
  let zostatokPoSplateni = 0;
  const limitMesiace = Math.min(horizontMesiace, dlzkaHypoMesiace);

  for (let m = 1; m <= limitMesiace; m++) {
    const investiciaTeraz = Number(priebehKrivky[m - 1] || 0);
    const zostatokHypo = Number(zostatky[m - 1] || 0);

    if (investiciaTeraz >= zostatokHypo && zostatokHypo > 0) {
      mesiacSplatenia = m;
      zostatokPoSplateni = investiciaTeraz - zostatokHypo;
      break;
    }
  }

  const usetreneMesiace = mesiacSplatenia
    ? Math.max(0, dlzkaHypoMesiace - mesiacSplatenia)
    : 0;

  return {
    priebehKrivky,
    konecnyStavBezPS: zaokruhliNa2(konecnyStavBezPS),
    celkoveVklady: zaokruhliNa2(celkoveVklady),
    celkovyVynos: zaokruhliNa2(celkovyVynos),
    mesiacSplatenia,
    usetreneMesiace,
    zostatokPoSplateni: zaokruhliNa2(zostatokPoSplateni),
  };
}